import React from 'react';
import QuotaModal from './QuotaModal';

/**
 * KYC 配额/订阅到期统一提示框
 * @param {boolean|string} status - false 不显示；'expired' 显示订阅到期文案；其他真值显示额度用完文案
 * @param {function} onClose - 关闭回调
 */
const KycQuotaModal = ({ status, onClose }) => {
  const expired = status === 'expired';

  return (
    <QuotaModal
      isOpen={!!status}
      onClose={onClose}
      title={expired ? 'Subscription Expired' : 'Name Screening Quota Reached'}
      contentLines={
        expired
          ? [
              'Your iCOMPASS KYC subscription has expired.',
              'Screening is disabled until your subscription is renewed.',
            ]
          : [
              "You've reached your screening quota for this billing period.",
              'Further searches are temporarily disabled.',
            ]
      }
      warningText={
        expired
          ? 'Please contact the iCOMPASS Team to renew your subscription.'
          : 'Please contact the iCOMPASS Team to upgrade your plan.'
      }
    />
  );
};

export default KycQuotaModal;
